import React from 'react';
import { CLOSING_BODY, CLOSING_LINE, CLOSING_SUB } from '../data/sushiContent';
export function ClosingCtaSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="closing-title" data-id="element-42" data-mp="34vtgu3nxvbue">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-43" data-mp="3jkpo3yi68kty">
        <h2 id="closing-title" className="font-display text-[1.7rem] italic leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-44" data-mp="3em4pg3iki97m">
          {CLOSING_LINE}
        </h2>
        <p className="mt-2 font-display text-[1.7rem] italic leading-tight text-champagne sm:text-[2.25rem]" data-id="element-45" data-mp="2ly8scxp36fab">
          {CLOSING_SUB}
        </p>
        <p className="mx-auto mt-5 max-w-md text-[14px] leading-relaxed text-body sm:text-[15px]" data-id="element-46" data-mp="30wb1dnevzsyy">
          {CLOSING_BODY}
        </p>
      </div>
    </section>;
}